/* Maker Legacy section. Live requests use a normal FormSubmit POST; previews stay local. No fetch, storage, or analytics. */
(() => {
  'use strict';
  const globalKey = '__mwInstitutionApplications';
  if (window[globalKey]) { window[globalKey].init(document); return; }
  const initialized = new WeakSet();
  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const form = root.querySelector('form.mw-app-form');
    if (!form) return;
    const preview = root.dataset.preview === 'true';
    const fields = root.querySelector('[data-app-fields]');
    const error = root.querySelector('[data-form-error]');
    const result = root.querySelector('[data-application-result]');
    const field = key => form.querySelector(`[data-field="${key}"]`);
    const read = key => field(key).value.trim();
    const button = root.querySelector('[data-submit]');
    const updateOther = () => {
      const needed = read('use') === 'Other';
      root.querySelector('[data-other-field]').hidden = !needed;
      field('otherUse').disabled = !needed;
      field('otherUse').required = false;
    };
    const updateEquipment = () => {
      const needed = read('printerBrand') === 'Other' || read('filamentType') === 'Other';
      root.querySelector('[data-equipment-other-field]').hidden = !needed;
      field('equipmentOther').disabled = !needed;
      field('equipmentOther').required = needed;
    };
    const rows = () => [
      ['Organization', read('organization')], ['Type', read('organizationType')],
      ['Location', read('location')], ['Email', read('email')],
      ['Printer brand', read('printerBrand')], ['Filament type', read('filamentType')],
      ...(read('printerBrand') === 'Other' || read('filamentType') === 'Other' ? [['Other equipment details', read('equipmentOther')]] : []),
      ['Use', (read('use') || 'Not provided') + (read('use') === 'Other' && read('otherUse') ? ' — ' + read('otherUse') : '')],
      ['Printer access', field('printer').checked ? 'Confirmed' : 'Not confirmed']
    ];
    function validate() {
      form.querySelectorAll('input[data-field]:not([type=checkbox])').forEach(input => { input.value = input.value.trim(); });
      updateOther(); updateEquipment();
      const invalid = [...form.elements].find(el => el.willValidate && !el.checkValidity());
      if (!invalid) { error.hidden = true; return true; }
      const messages = {
        organization: 'Please enter your organization name.', organizationType: 'Please choose an organization type.',
        location: 'Please enter your city and state.', email: 'Please enter a valid contact email.',
        printerBrand: 'Please select your main printer brand.', filamentType: 'Please select your main filament type.',
        equipmentOther: 'Please specify the other printer or filament.',
        printer: 'Please confirm that your organization has access to a filament-based 3D printer.'
      };
      error.textContent = messages[invalid.dataset.field] || 'Please complete this field.';
      error.hidden = false; invalid.focus(); invalid.reportValidity(); return false;
    }
    function showPreview() {
      if (!validate()) return;
      const summary = root.querySelector('[data-request-summary]');
      summary.replaceChildren();
      for (const [label, value] of rows()) {
        const dt = document.createElement('dt'); const dd = document.createElement('dd');
        dt.textContent = label; dd.textContent = value; summary.append(dt, dd);
      }
      form.hidden = true; result.hidden = false; result.querySelector('h3').focus();
    }
    // Bind the submit blocker before enabling the preview fieldset.
    form.addEventListener('submit', event => {
      if (preview) { event.preventDefault(); showPreview(); return; }
      if (!validate()) { event.preventDefault(); return; }
      form.querySelector('[data-message-body]').value = 'MarsWork Maker Legacy — Institution support request\n\n' + rows().map(([key, value]) => `${key}: ${value}`).join('\n');
      // Allow the normal FormSubmit POST and default spam protection. Provider handles the result; no client-side success state.
    });
    if (preview) button.addEventListener('click', showPreview);
    field('use').addEventListener('change', updateOther);
    field('printerBrand').addEventListener('change', updateEquipment);
    field('filamentType').addEventListener('change', updateEquipment);
    form.addEventListener('input', () => { error.hidden = true; });
    form.addEventListener('change', () => { error.hidden = true; });
    root.querySelector('[data-edit-application]').addEventListener('click', () => {
      result.hidden = true; form.hidden = false; field('organization').focus();
    });
    form.setAttribute('aria-describedby', root.querySelector('.required-note').id);
    updateOther(); updateEquipment();
    if (preview) fields.disabled = false;
  }
  function init(scope) {
    if (scope.matches && scope.matches('[data-mw-institution-app]')) initialize(scope);
    scope.querySelectorAll('[data-mw-institution-app]').forEach(initialize);
  }
  window[globalKey] = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
